export const environment = {
  production: true,
  tel: "34733131",
  area: "35",
  hasCashback: false,
  hasRecharge: false,
  rechargeLimit: 100.00,
  rechargeBalanceLimit: 500.00,
  url: "https://api.test.reconline.nowigo.com.br",
};
